export const AboutMission = () => {
  return (
    <section className="text-center space-y-8">
      <h2 className="text-3xl font-semibold">Our Mission</h2>
      <div className="space-y-6 text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed">
        <p>
          At Home Pros OKC, we started with a simple truth: inviting someone into your home isn't just about getting a job done – it's about trust. We know firsthand that having a stranger work on your property can feel uncomfortable, even if it's necessary.
        </p>
        <p>
          That's why we set out to create something different. We're not just connecting you with contractors; we're introducing you to carefully vetted professionals who understand they're guests in your space. Every pro in our network has proven themselves not just in their craft, but in their ability to respect your home and your trust.
        </p>
        <p>
          Our platform makes it easy to find, evaluate, and connect with the best contractors in Oklahoma City. But more importantly, it gives you peace of mind knowing you're working with people who treat your home as carefully as they would their own.
        </p>
      </div>
    </section>
  );
};